<template>
  <font-awesome-icon
    icon="sync-alt"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons'

library.add(faSyncAlt)

export default {
  name: 'CoozzySyncAltIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
